export class ManifestValidationError extends Error {
  constructor(message: string, error?: Error) {
    super(message);
    this.stack = error?.stack;
    this.name = 'ManifestValidationError';
  }
}
